<div
    style="display:inline-block"
    (click)="changeMode()"
    id="simple-mode-switch"
    [nTooltip]="isSimpleMode ? i18nStr.advanceModeTip : i18nStr.simpleModeTip"
    nTooltipPlacement="bottom">
    <svg class="icon header-icon">
        <use xlink:href="#app-icon-mode-switch"></use>
    </svg>
</div>
